import VerifyPhoneWrapper from './VerifyPhoneWrapper';

export default VerifyPhoneWrapper;
